import { createContext } from "react";

const fleetContext = createContext();

export default fleetContext;
